// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { GroupSecurity } from '@quromedical/fhir-common';
import { ConsumableGetAllResponse, ConsumableUsage } from '@quromedical/models';
import { ConfirmationButton } from 'components/input';
import { ColumnType } from 'components/table';
import { WithGroup } from 'core/auth';
import { getDisplayDate } from 'core/display';
import { logger } from 'helpers';
import { useRevalidation } from 'hooks/useRevalidation';
import { ConsumableApi } from 'integration/aggregate';
import { useCallback } from 'react';
import { strings } from 'strings';

interface UpdateConsumableStatusButtonProps {
  consumableId: string;
}

const api = new ConsumableApi();

const UpdateConsumableStatusButton: React.FC<UpdateConsumableStatusButtonProps> = ({
  consumableId,
}) => {
  const revalidate = useRevalidation('Consumable');

  const onSubmit = useCallback(async () => {
    await api.updateConsumableStatus({ id: consumableId, status: 'entered-in-error' });
    revalidate().catch(logger.error);
  }, [consumableId, revalidate]);

  return (
    <ConfirmationButton
      status="status-critical"
      title={strings.ConsumableConfirmationButtonTitle}
      message={strings.ConsumableConfirmationButtonMessage}
      onSubmit={onSubmit}
      buttonText={strings.ConsumableConfirmationButtonText}
    />
  );
};

export interface ConsumableTableData {
  id: string;
  name: string;
  quantity: number;
  dateOfUse: string;
  practitioner: string;
  status: string;
}

export type ConsumableRequestTableData = ConsumableUsage;

export const consumableColumns: ColumnType<ConsumableTableData>[] = [
  {
    header: strings.LabelConsumable,
    accessor: 'name',
  } as ColumnType<ConsumableTableData, 'name'>,
  {
    header: strings.LabelConsumableQuantity,
    accessor: 'quantity',
  } as ColumnType<ConsumableTableData, 'quantity'>,
  {
    header: strings.LabelConsumableUsageDate,
    accessor: 'dateOfUse',
  } as ColumnType<ConsumableTableData, 'dateOfUse'>,
  {
    header: strings.LabelConsumablePractitioner,
    accessor: 'practitioner',
  } as ColumnType<ConsumableTableData, 'practitioner'>,
  {
    accessor: 'status',
    header: strings.LabelConsumableActions,
    Cell: value =>
      value.row.original.status === 'entered-in-error' ? (
        value.row.original.status
      ) : (
        <WithGroup groups={[GroupSecurity.ChargeItemDefinitionUpdate]}>
          <UpdateConsumableStatusButton consumableId={value.row.original.id} />
        </WithGroup>
      ),
  } as ColumnType<ConsumableTableData, 'status'>,
];

export const getDataFromResponse = (
  res: ConsumableGetAllResponse
): Partial<ConsumableTableData>[] =>
  res.consumableUsages.map(consumable => ({
    ...consumable,
    practitioner: consumable.performer?.display || strings.DisplayNotFound,
    dateOfUse: getDisplayDate(consumable.dateOfUse),
  }));
